import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-export-employee-zip',
  templateUrl: './export-employee-zip.component.html',
  styleUrls: ['./export-employee-zip.component.scss']
})
export class ExportEmployeeZipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
